"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionButtons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var add_customer_1 = __importDefault(require("../components/add_customer"));
var IUser_1 = require("../../../../../interfaces/IUser");
var download_user_records_1 = require("../../../../../api/calls/user/download_user_records");
var export_client_users_to_csv_1 = require("../../../../../api/calls/user/get/export_client_users_to_csv");
var main_1 = require("../../../../../reducers/slices/main");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var permissions_1 = __importDefault(require("../../../../../hooks/permissions"));
function useActionButtons() {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var customersPermissions = (0, permissions_1.default)(IUser_1.IPermissions.CUSTOMERS);
    var actionButtons = (0, react_1.useMemo)(function () { return [
        {
            iconClassname: "solar:cloud-download-bold",
            label: "Export",
            onClick: function () {
                (0, export_client_users_to_csv_1.get_loyalty_users_download_url)({
                    user_id: user === null || user === void 0 ? void 0 : user._id,
                })
                    .then(function (data) {
                    (0, download_user_records_1.download_user_record_file)(data.content)
                        .then(function (response) {
                        var blob = new Blob([response.file_data], { type: "application/octet-stream" });
                        var url = window.URL.createObjectURL(blob);
                        var link = document.createElement("a");
                        link.href = url;
                        link.download = response.file_name;
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                        .catch(function (e) {
                        console.log("download_user_record_file error: ", e);
                    });
                })
                    .catch(function (error) {
                    console.log("get_loyalty_users_download_url error: ", error);
                });
            },
        },
        customersPermissions.canCreate && {
            iconClassname: "solar:add-circle-bold",
            label: "Add Customer",
            onClick: function () {
                dispatch((0, main_1.setContentModal)({
                    title: "Add Customer",
                    content: (0, jsx_runtime_1.jsx)(add_customer_1.default, {}),
                }));
            },
        },
    ]; }, []);
    return (0, react_1.useMemo)(function () { return ({
        actionButtons: actionButtons,
    }); }, [actionButtons]);
}
exports.useActionButtons = useActionButtons;
